import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherStudentDetails } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const teacherRetrieveStudent = createAsyncThunk<TeacherStudentDetails, string, { extra: Partial<Dependencies> }>(
  "teachers/teacherRetrieveStudent",
  async (email: string, { extra: { teacherRepository } }) => {
    return teacherRepository!.getStudentByEmail(email);
  },
);

export const resetTeacherStudentRetrieval = createAction("teachers/resetTeacherStudentRetrieval");
